<template>
  <draggable :element="'div'" :list="navigation" :options="{group:{ name:'g1'}}" class="navigationSort">
    <div class="navigationDrag" v-for="element in navigation" :key="element.id">
      <NavigationItem :element="element" :parentNavigation.sync="navigation"/>
      <DraggableLocal :navigation.sync="element.data"/>
    </div>
  </draggable>
</template>

<script>
import NavigationItem from '@/components/Navigation/NavigationItem'
import DraggableLocal from '@/components/Navigation/DraggableLocal'
import draggable from 'vuedraggable'

export default {
  name: 'DraggableLocal',
  components: {
    NavigationItem, DraggableLocal, draggable
  },
  props: ['navigation']
}
</script>

<style lang="stylus">
  .navigationSort
    min-height 5px
    position relative
    z-index 1
    overflow hidden
    padding-bottom 20px

    .navigationSort
      padding-bottom 0

      &:after
        content ''
        display block
        border-bottom 2px dashed #CCC
        height 5px

  .navigationDrag
    position relative
    margin 5px 0

    .navigationDrag
      padding-left 20px

</style>



// WEBPACK FOOTER //
// src/components/Navigation/DraggableLocal.vue